import {Component, Event, EventEmitter, h, Host, Prop, State, Watch} from '@stencil/core';
import {FormRenderer} from '../../domain/form-renderer-connect';
import { _debug } from '../../common/debugger/debugger';

@Component({
  tag: 'fert-form-renderer',
  styleUrl: 'styles.scss',
  shadow: true,
})
export class FertFormRenderer {
  @Prop() definitionurl; // definition of the form (layout)
  @Prop() userdecisions; // offline, preview
  @Prop() metadata; // ... tbd
  @Prop() userdata; // user data
  @Prop() uploadendpoint; // endpoint for uploading attachments
  @Prop() catalogendpoint; // country list, etc..

  @Prop() i18n; // formular-texts in different languages

  formRenderer;

  @Prop() data; // data from outside, fill form with this data

  @Watch('data')
  handleDataGiven(data) {
    this.formRenderer.setData(data);
  }

  @Event() formrendererinitiated: EventEmitter;
  @Event() datachanged: EventEmitter<any>;
  @Event() pagechanged: EventEmitter<any>;
  @Event() ageinfo: EventEmitter<any>;
  @Event() optionalDataGiven: EventEmitter<any>;
  @Event() formValidated: EventEmitter<any>;
  @Event() filesUploaded: EventEmitter<any>;
  @Event() dataUpdate: EventEmitter<any>;
  @Event() tidyDataUpdate: EventEmitter<any>;
  @Event() anlagenVerzeichnis: EventEmitter<any>;

  @Prop() definition; // definition of the form (layout)

  @Watch("definitionurl")
  getFormDefinition() {

    fetch(this.definitionurl, {
      method: "GET",
      headers: {
        "X-CSRF-TOKEN": "true",

        Prefer: "example=beschwerde", // very large lbabeschwerde, changing pages: entlassung, simple: beschwerde
      },
    }).then((resp) => {
      resp["json"]().then((result) => {
        this.definition = result;

        _debug("this.state:", this.state)

      });
    });
  }

  @Watch("definition")
  initRenderer() {

    if(this.formRenderer) {
        console.warn('form renderer already initiated')
        return;
    }
    this.state == 'initiating'

    document.getElementById('formio').style.display = 'block';
    this.formRenderer = new FormRenderer(
      'formio',
      this.definition,
      this.userdecisions,
      this.metadata,
      this.userdata,
      this.uploadendpoint,
      this.catalogendpoint,
      this.i18n
    );

    this.formRenderer.on('initiated', (options) => {
      this.formrendererinitiated.emit(options);
      this.publishUpdates();
      this.state == 'initiated';
    });

    this.formRenderer.on('dataChange', (changed) => {
        _debug('change:' + changed)
      this.datachanged.emit(changed);
      this.publishUpdates()
    });

    this.formRenderer.on('changedPage', (pagedata) => {

      this.pagechanged.emit(pagedata);

      if(pagedata && pagedata.currentPage && pagedata.currentPage.isSummary) {
        this.updatePayload();
      }

      const optionalDataGiven = this.formRenderer.needsOptionalApproval();      
      this.optionalDataGiven.emit(optionalDataGiven);

      this.publishUpdates()

      this.pageinfos = pagedata.pageInfos;

      if (pagedata?.currentPage?.isSummary) {
        const isValid = this.formRenderer.isFormValid();
        _debug('is form valid?')
        _debug(this.formRenderer.isFormValid())
        _debug(this.formRenderer)

        this.formValidated.emit(isValid);
      }
    });
  }

  @State() pageinfos;

  publishUpdates() {
    // check if optional data, age info, uploads given
    const ageInfo = this.formRenderer.getAgeInfo();

    const uploads = this.formRenderer.getDocumentIds();

    const tidyData = this.formRenderer.getTidyData();

    const anlagenVerzeichnis = this.formRenderer.getAnlagenverzeichnis();

    if (ageInfo) {
      this.ageinfo.emit(ageInfo);
    }

    if (uploads && uploads.length && uploads.length > 0) {
      // ToDo: make this more reliable
      this.filesUploaded.emit(uploads);
    }

    if (tidyData) {
      // ToDo: make this more reliable
      this.tidyDataUpdate.emit(tidyData);
    }

    if (anlagenVerzeichnis) {
      this.anlagenVerzeichnis.emit(anlagenVerzeichnis);
    }
  }

  updatePayload() {
    this.formRenderer.getPayload().then((res) => {
      if (res && res.data) {
        // ToDo: make this more reliable
        this.dataUpdate.emit(res.data);
      }
    })
  }

  @State() state: 'initiating' | 'initiated' = 'initiating';

  style = `
  .wizard-sticky-wrapper {
    display: none;
  }
  .wizard-page {
      margin: 0!important;
      width: 100%!important;
      padding: 0!important;
  }`;

  nonce;

  componentDidLoad() {
    if (this.definition) {
      this.initRenderer();
    }
    
    // CSP Adjustments
    const metaNonce: HTMLMetaElement = document.querySelector(
      "meta[property='csp-nonce']"
    );
    this.nonce = metaNonce ? metaNonce.content : "__NONCE__";

    var head = document.head || document.getElementsByTagName('head')[0],
    style = document.createElement('style');

    style.nonce = this.nonce;

    style.appendChild(document.createTextNode(this.style));

    head.appendChild(style);

  }

  @State() formPageLinks;  

  @Watch('pageinfos')
  getCurrentActivePage() {
   
    this.formPageLinks = this.pageinfos.map( (page) => {
      return {
        index: page.index,
        url: '#'+ page.index,
        label: page.title,
        active: page.active
      }     
    })
    
  }

  render() {
    return (
      <Host>
        
        <m-menu-dropdown data-testid="navigation-dropdown" ordered links={ this.formPageLinks }></m-menu-dropdown>

        <section class="form-renderer">
          <slot />
        </section>   
      </Host>
    );
  }
}
